"use client";
import Script from "next/script";
import {evaluateConsentManagementEnabledAction} from "@/lib/EvaluateFlagAction";
import {useEffect, useState} from "react";

export default function OsanoConsentManagement() {
	const [consentManagementEnabled, setConsentManagementEnabled] =
		useState(false);

	useEffect(() => {
		async function checkConsentManagement() {
			const enabled = await evaluateConsentManagementEnabledAction();
			setConsentManagementEnabled(enabled);
		}
		checkConsentManagement();
	}, []);

	if (!consentManagementEnabled) {
		return <></>;
	}

	return (
		<Script
			src="https://cmp.osano.com/EvHV0kRj0s/820a9092-2ae0-4562-b723-c230167bec06/osano.js"
			strategy="afterInteractive"
		/>
	);
}
